(function () {

  var li = document.querySelectorAll('ul.navbar-mobile_menu li.level-1 a.navbar-mobile_item-link');
  li.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
    });
  });

  //Scroll to: data-scroll-to data-target
  const anchorScrollTo = () => {
    const scrollToElements = document.querySelectorAll('[data-scroll-to]');

    const clickEvent = (event) => {
      event.preventDefault();

      const dataTarget = event.target.getAttribute('data-target');
      document.querySelector(dataTarget).scrollIntoView();
    }

    scrollToElements.forEach((elem) => {
      elem.addEventListener('click', clickEvent);
      elem.addEventListener('tap', clickEvent);
    });

  }
  anchorScrollTo();

  document.querySelectorAll('vimeo-embed').forEach(v => {
    v.innerHTML = `<img loading="lazy" src="https://vumbnail.com/${v.id}.jpg" alt="${v.title}"><button aria-label="Play"></button>`;
    v.children[1].addEventListener('click', () => v.innerHTML = `<iframe allow="autoplay" src="https://player.vimeo.com/video/${v.id}?autoplay=1"></iframe>`)
  });

})();